import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_ctrl_acc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  amt_debit: fromDatatype.MoneyDatatypeInterface;
  amt_credit: fromDatatype.MoneyDatatypeInterface;
  balance_debit: fromDatatype.MoneyDatatypeInterface;
  balance_credit: fromDatatype.MoneyDatatypeInterface;
  master_ledger_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_ctrl_acc_line_RowClass implements bl_fi_ctrl_acc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  amt_debit: fromDatatype.MoneyDatatypeInterface;
  amt_credit: fromDatatype.MoneyDatatypeInterface;
  balance_debit: fromDatatype.MoneyDatatypeInterface;
  balance_credit: fromDatatype.MoneyDatatypeInterface;
  master_ledger_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


